module.exports = __webpack_public_path__ + "img/img_1.a7e6ddf5.png";